import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import TaxDetail from './components/TaxDetails.vue';
let default_1 = class extends Vue {};
default_1 = __decorate([Component({
  name: 'ManageTax',
  components: {
    TaxDetail
  },
  props: ['isEdit']
})], default_1);
export default default_1;